import MappedClinicAndCityPage from "@/app/routes/error_routes/MapClinicAndCityPage";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import config from "@/configs/development";
import { VMS_CLICK_EVENTS, VMS_SCREEN_IDS, useVMSClickLog } from "@/app/hooks/useVMSClickLog";

const MappedClinic = () => {
  const [isVisibleMappedClinic, setIsVisibleMappedClinic] = useState<boolean>(false);
  const { mappedClinicName } = useAppSelector((state) => state.root.UIStates);
  const { logVMSClick } = useVMSClickLog(VMS_SCREEN_IDS.HEADER);

  useEffect(() => {
    setIsVisibleMappedClinic(false);
  }, [mappedClinicName]);
  const isDevEnv =
    window.location.hostname.includes("dev.") ||
    window.location.hostname === "localhost" ||
    window.location.hostname.includes("test.");

  return (
    <div className="flex items-center gap-x-2 min-w-0">
      <a
        className="flex justify-start items-center gap-x-2 text-blue-600 cursor-pointer min-w-0"
        onClick={() => {
          logVMSClick(VMS_CLICK_EVENTS.HEADER_MAPPED_CLINIC_CLICK, mappedClinicName ?? "Map Your Designated Clinic");
          setIsVisibleMappedClinic(true);
        }}
      >
        <span className="shrink-0">
          <MapPinIcon className="w-4 h-4 " />
        </span>
        <span className="text-[10px] sm:text-xs truncate whitespace-nowrap">
          {mappedClinicName ?? "Map Your Designated Clinic"}
        </span>
      </a>
      {isDevEnv && (
        <p className="bg-red-200 text-red-600 px-2 rounded-md hidden sm:flex items-center whitespace-nowrap shrink-0">
          {config.env.mode}
        </p>
      )}
      {isVisibleMappedClinic && (
        <MappedClinicAndCityPage isCrossVisible={true} setIsVisibleMappedClinic={setIsVisibleMappedClinic} />
      )}
    </div>
  );
};

export default MappedClinic;
